import { FC, ReactNode } from 'react';

import { Flex } from 'antd';
import cn from 'classnames';

import { WithLink } from '@/shared-components/utility';

import styles from './IndicationCard.module.scss';

type Props = {
	title?: string;
	href?: string;
	indicator: ReactNode;
	classNames?: {
		indicator?: string;
		description?: string;
	};
	indicatorIcon?: ReactNode;
	description?: ReactNode;
	descriptionIcon?: ReactNode;
	descriptionColor?: string;
};

export const IndicationCard: FC<Props> = ({
	title,
	indicator,
	indicatorIcon,
	description,
	descriptionIcon,
	descriptionColor = '#f3f6fa',
	classNames,
	href,
}) => {
	return (
		<WithLink href={href}>
			<div className={cn(styles.cardContainer, href && styles.hovered)}>
				<div className={styles.mainContent}>
					{title && <div className={styles.title}>{title}</div>}
					<Flex justify={indicatorIcon ? 'space-between' : 'end'} align="center">
						{indicatorIcon && indicatorIcon}
						<div className={cn(styles.indicator, classNames?.indicator)}>{indicator}</div>
					</Flex>
				</div>
				<Flex
					className={styles.descriptionContainer}
					style={{ background: descriptionColor }}
					justify={descriptionIcon ? 'space-between' : 'end'}
					align="center"
				>
					{descriptionIcon && descriptionIcon}
					<div className={cn(styles.description, classNames?.description)}>{description}</div>
				</Flex>
			</div>
		</WithLink>
	);
};
